// action: optional { label, onClick } button, e.g. { label: "Undo", onClick: revert }.
export function showToast({ kind = "info", title, body, action } = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("app-toast", { detail: { kind, title, body, action } }));
}
